module.exports = __webpack_public_path__ + "static/media/IMG_3483_sm.4c779332.jpg";